import './user_profile_attribute_view.js.coffee'

class Customer.FixedStringUserProfileAttributeView extends Customer.UserProfileAttributeView
  template: JST["backbone/templates/customer/users/custom_attributes/fixed_string"]

  events:
    'click .add-new-value': '_onAddTag'

  render: ->
    super
    @disabled = false
    @tagsView = @selectView()
    @listenTo @tagsView, 'change', =>
      @$el.find('.chosen-container').hide()
      @trigger 'profile_custom_attributes:modified_field'
      @updateAddTag()
    @$el.find('#tags').append(@tagsView.el)
    @$el.find('.chosen-container').hide()
    @$el.find('.add-new-value').addClass('disabled') unless @canAddValue()
    @

  selectedOptions: ->
    _.pluck(
      _.filter(
        @model.get('definition').tags,
        (tag) => tag.name in @initialValues()
      ),
      'id'
    )

  _onAddTag: ->
    @$el.find('.chosen-container').show()
    @trigger 'profile_custom_attributes:modified_field'
    @updateAddTag()

  canAddValue: ->
    multiple = @model.get('definition').multiple
    tagsAdded = @$el.find('#tags .tags .label').length > 0
    !tagsAdded || multiple || (tagsAdded && multiple)

  updateAddTag: ->
    if @canAddValue()
      @$el.find('.add-new-value').removeClass('disabled')
    else
      @$el.find('.add-new-value').addClass('disabled')

  selectView: ->
    if @model.get('definition').multiple
      view = App.SelectView
    else
      view = App.UniqueSelectView
    new view
      selectedOptions: @selectedOptions()
      options: _.sortBy(@model.get('definition').tags, (tag) -> tag.order)
      valueProperty: 'id'
      descriptionProperty: 'name'
      placeholder: I18n.t('user_profiles.custom_attributes.add_tag')


  getAdded: ->
    definition_code: @model.get('definition').code,
    values: _.filter(
      _.difference(@tagsView.toDescriptionArray(), @initialValues()),
      (value) -> value
    )

  getDeleted: ->
    definition_code: @model.get('definition').code,
    values: _.filter(
      _.difference(@initialValues(), @tagsView.toDescriptionArray()),
      (value) -> value
    )

  disableFurtherChange: ->
    @$el.find('.chosen-container').hide()
    @$el.find('.add-new-value').addClass('disabled')
    @$el.find('.label').addClass('disabled')
    @tagsView.setEditable(false)
    @disabled = true
